import * as React from 'react';
import { MenuProvider } from '../../contexts/menuContext';
/**
 * Render the final JSX of Menu
 */
export const renderMenu_unstable = (state, contextValues) => {
  return /*#__PURE__*/React.createElement(MenuProvider, {
    value: contextValues.menu
  }, state.menuTrigger, state.open && state.menuPopover);
};